import { useEffect } from 'react'
import { fetchCruiseDealBySlug } from 'actions/CruiseActions'
import { useAppDispatch, useAppSelector, shallowEqual } from 'hooks/reduxHooks'

export function useCruiseDealBySlug(slug?: string): [App.Cruises.CruiseDeal | undefined, boolean, string | undefined] {
  const dispatch = useAppDispatch()
  const cruiseDealsBySlug = useAppSelector((state) => state.cruise.cruiseDealsBySlug, shallowEqual)

  useEffect(() => {
    if (slug) {
      dispatch(fetchCruiseDealBySlug(slug))
    }
  }, [slug, dispatch])

  const { deal, fetching, error } = cruiseDealsBySlug[slug!] || {}

  return [
    deal,
    fetching || false,
    error,
  ]
}
